module.exports = "../dist/img/product-card-.93b3.jpg";